<template>
	<v-app>
		<navbar v-if="$route.name !== 'login'"></navbar>
		<v-main>
			<router-view/>
		</v-main>

		<v-snackbar
			text
			shaped
			v-model="showSnackbar"
			:color="isErrorMessage ? 'error' : 'myGreen'">
			<div class="text-center">
				{{ message }}
			</div>
		</v-snackbar>
	</v-app>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  components: { Navbar },
	name: 'App',

	component: {
		Navbar
	},

	data: () => ({
		showSnackbar: false,
		message: '',
		isErrorMessage: false
	}),

	created () {
		this.$store.dispatch('auth/fetchCenters').then(() => {
			if (this.$route.name === 'login') this.loading = false
		})

		this.$eventBus.$on('show-snackbar', (isErrorMessage, message) => {
			this.message = message
			this.isErrorMessage = isErrorMessage
			this.showSnackbar = true
		})

		this.$eventBus.$on('loader', (status) => {
			this.loading = status
		})
	}
}
</script>

<style>
@font-face {
	font-family: Fairuz;
	src: url('./assets/Fairuz/Fairuz-Light.otf');
	font-weight: 100 300;
}
@font-face {
	font-family: Fairuz;
	src: url('./assets/Fairuz/Fairuz-Normal.otf');
	font-weight: 400;
}
@font-face {
	font-family: Fairuz;
	src: url('./assets/Fairuz/Fairuz-Bold.otf');
	font-weight: 500 700;
}
@font-face {
	font-family: Fairuz;
	src: url('./assets/Fairuz/Fairuz-Black.otf');
	font-weight: 800 900;
}
* {
	font-family: Fairuz;
}
</style>
